<script setup>
  import {computed} from "vue";

  import ComponentIcon from "@components/Icons/Icon.vue";
  import {usePage} from "@inertiajs/vue3";
  import PatientinputComponentStep from "@pages/Patientinput/Components/Step.vue";
  import {MedButton} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "PatientinputComponentStepWelcomeCarer",
  });

  defineProps({
    form: {
      type: Object,
      required: true,
    },
  });

  defineEmits(["navigate"]);

  const page = usePage();

  const company = computed(() => page.props.company);
</script>

<template>
  <PatientinputComponentStep
    :forward-button="false"
    :back-button="false"
    :navigation-horizontal="false"
    :test-id="getTestId()"
  >
    <template #title>
      <Teleport defer to="#patientinput-layout-header">
        <header>
          <img src="@images/logo/mc_logo.svg" width="250" alt="MediCheck" class="mt-3" />
        </header>
      </Teleport>
    </template>

    <h1 class="text-center text-2xl font-medium md:text-4xl">
      Fragebogen zur Datenerfassung für die Medikationsberatung
    </h1>

    <img src="@images/hero-image.jpg" alt="" class="rounded" />

    <p>Sehr geehrte Pflegefachkraft,</p>

    <p>
      dieser digitale Fragebogen soll Sie bei der Erfassung wichtiger Informationen für die Medikationsberatung von
      Patienten im Alten- und Pflegeheim unterstützen (Dauer ca. 5 Minuten).
    </p>

    <p>
      Verantwortlich für die Datenverarbeitung im Sinne der DSGVO ist
      <span v-if="company">{{ company }}.</span>
      <span v-else>Ihre Apotheke.</span>
    </p>

    <div class="align-start flex space-x-2 text-blue-900">
      <ComponentIcon class="inline-block text-2xl text-blue-600">info</ComponentIcon>
      <p>
        Mit der Eingabe willigt der/die Patient*in ausdrücklich in die Verarbeitung seiner/ihrer Gesundheitsdaten gemäß
        Datenschutzerklärung ein.
      </p>
    </div>

    <template #navigation>
      <MedButton variant="primary" :data-test="getTestId('welcome-carer-step-button')" @click="$emit('navigate', '+')">
        Mit der Eingabe starten
      </MedButton>
    </template>
  </PatientinputComponentStep>
</template>
